import React from 'react'

const ProductContent = ({containerObject}) => {
  return (
    <>
    <p>ProductContent</p>
        {containerObject && containerObject.targeterResult ? <div dangerouslySetInnerHTML={{ __html: containerObject.targeterResult }}  ></div> : ""}

    </>
  )
}

export default ProductContent